import { SvgIcon, SvgIconProps } from '@mui/material'

export const EducationalIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
      <g clip-path="url(#clip0_3653_8772)">
        <path
          d="M10 2.5L0.833344 7.5L4.16668 9.31667V14.3167L10 17.5L15.8333 14.3167V9.31667L17.5 8.40833V13.3333C17.5 13.7936 17.8731 14.1667 18.3333 14.1667C18.7936 14.1667 19.1667 13.7936 19.1667 13.3333V7.5L10 2.5ZM15.6833 7.5L10 10.6L4.31668 7.5L10 4.4L15.6833 7.5ZM14.1667 13.325L10 15.6L5.83334 13.325V10.225L10 12.5L14.1667 10.225V13.325Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3653_8772">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}
